import { ChangeDetectionStrategy, Component, EventEmitter, input, InputSignal, Output } from '@angular/core';

export type SzLangCode = 'pl' | 'en';

@Component({
  selector: 'sz-lang-toggle',
  templateUrl: './sz-lang-toggle.component.html',
  styleUrls: ['./sz-lang-toggle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SzLangToggleComponent {
  readonly current: InputSignal<SzLangCode> = input.required<SzLangCode>();

  @Output() readonly select: EventEmitter<SzLangCode> = new EventEmitter<SzLangCode>();

  onSelect(lang: SzLangCode): void {
    if (this.current() === lang) return;
    this.select.emit(lang);
  }
}
